import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useCidco } from "./CidcoLayout";
import { Link2, ExternalLink, FileText } from "lucide-react";

export default function ImportantLinks() {
  const data = useCidco();
  const links = data.links || [];
  return (
    <div data-testid="cid-links">
      <PageHero eyebrow="Resources" title="Important Links" />
      <PageBody>
        {links.length === 0 ? (
          <div className="bg-white rounded-2xl p-12 text-center text-sm text-[#475569] ring-1 ring-[#E2E8F0]">
            Important links will appear here once published by the institute.
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4">
            {links.map((l) => {
              const url = l.file_url || l.external_url;
              const isPdf = !!l.file_url;
              return (
                <a key={l.id} href={url || "#"} target="_blank" rel="noopener noreferrer"
                   className="bg-white rounded-xl p-5 ring-1 ring-[#E2E8F0] hover:ring-2 hover:ring-[#06B6D4] hover:shadow-md transition-all flex items-start gap-3">
                  {isPdf ? <FileText className="text-[#E55400] mt-0.5" size={20} /> : <Link2 className="text-[#06B6D4] mt-0.5" size={20} />}
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold text-[#0B2447]">{l.title}</div>
                    {l.description && <p className="mt-1 text-[12px] text-[#475569]">{l.description}</p>}
                  </div>
                  <ExternalLink size={14} className="text-[#475569]" />
                </a>
              );
            })}
          </div>
        )}
      </PageBody>
    </div>
  );
}
